import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
interface TransactionSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewTransactions: () => void;
}
export function TransactionSuccessModal({
  isOpen,
  onClose,
  onViewTransactions
}: TransactionSuccessModalProps) {
  return <AnimatePresence data-id="element-7041">
      {isOpen && <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-7042">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden" data-id="element-7043">
            {/* Header with close button */}
            <div className="relative p-6 pb-0" data-id="element-7044">
              <button onClick={onClose} className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-7045">
                <XIcon className="w-5 h-5 text-gray-500" data-id="element-7046" />
              </button>
            </div>

            {/* Content */}
            <div className="p-8 pt-4 text-center" data-id="element-7047">
              {/* Success Icon with animation */}
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 15,
            delay: 0.1
          }} className="w-24 h-24 mx-auto mb-6 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center shadow-xl" data-id="element-7048">
                <CheckCircleIcon className="w-14 h-14 text-white" data-id="element-7049" />
              </motion.div>

              {/* Success Message */}
              <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} data-id="element-7050">
                <h2 className="text-3xl font-bold text-slate-900 mb-3" data-id="element-7051">
                  Tranzacție Adăugată!
                </h2>
                <p className="text-slate-600 text-lg mb-8 leading-relaxed" data-id="element-7052">
                  Tranzacția ta simulată a fost salvată cu succes și este
                  disponibilă în lista de tranzacții.
                </p>
              </motion.div>

              {/* Action Buttons */}
              <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="space-y-3" data-id="element-7053">
                <button onClick={onViewTransactions} className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-all transform hover:scale-[1.02]" data-id="element-7054">
                  Vezi Tranzacțiile
                </button>
                <button onClick={onClose} className="w-full bg-slate-100 text-slate-700 px-6 py-4 rounded-xl font-semibold hover:bg-slate-200 transition-all" data-id="element-7055">
                  Continuă Simularea
                </button>
              </motion.div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}